
import QASection from '../components/QASection';
import VideoBackground from '../components/VideoBackground';
import Logo from '../components/Logo';
import OfferSection from '../components/OfferSection';
import WhyEvas from '../components/WhyEvas';
import Progress from '../components/ProcessSteps';

function Services() {
  

  return (
    <>
      <VideoBackground/>
      <Logo/>
      <OfferSection/>
      <Progress/>
      <WhyEvas/>
      <QASection/>
      
    </>  
  );
}

export default Services;